export default __webpack_public_path__ + "static/media/180_2V.f435e6cd.pdf";